module.exports = __webpack_public_path__ + "static/media/grubhub-logo-orange.77bcf029.svg";